import store from "../../store/store";

export const componentKey = "DASHBOARD_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
    setVisitList: (state, action) => {
      state.visitListData = action.payload;
    },
    setClosePreviewDialog: (state, action) => {
      state.closePreviewForDialog = action.payload;
    },
    setFacilityRooms: (state, action) => {
      state.facilityRooms = action.payload;
    },
    // Top ICD-10 / DSM codes for the dashboard card.
    setIcdSummary: (state, action) => {
      state.icdSummary = action.payload;
    },
  },
  initialReducerState: {
    dashboardData: {},
    visitListData: {},
    closePreviewForDialog: false,
    facilityRooms: [],
    icdSummary: {},
  },
});

export const {
  setDashboardData,
  setVisitList,
  setClosePreviewDialog,
  setFacilityRooms,
  setIcdSummary,
} = actions;
